/* eslint-disable */


import {
    FETCH_FOOTER_SUCCESS, FETCH_FOOTERITEMS_SUCCESS,
    FETCH_NAVITEMS_REQUEST, FETCH_NAVITEMS_SUCCESS
} from "../mutationTypes";
import ArticleApi from "@shared/_api/article";
import ContentAPI from "@shared/_api/cms/content";

const state = {
    navItems: [],
    footerItems: null
};

const getters = {
    filteredNavItems: (state) => state.navItems.filter(i => i.visible && i.visible.value),
};

const actions = {
    fetchNavItems({commit}) {
        ContentAPI.fetchListByName("menu").then(navItems => {
            commit(FETCH_NAVITEMS_SUCCESS, navItems);
        }).catch(error => {
            console.log(error);
        });
        ;
    },
    fetchFooterItems({commit}) {
        ContentAPI.fetchListByName("nav-footer").then(footerItems => {
            commit(FETCH_FOOTERITEMS_SUCCESS, footerItems);
        }).catch(error => {
            console.log(error);
        });
        ;
    },
};

const mutations = {
    [FETCH_NAVITEMS_SUCCESS](state, navItems) {
        state.navItems = navItems;
    },
    [FETCH_FOOTERITEMS_SUCCESS](state, footerItems) {
        state.footerItems = footerItems;
    }

};

export const shopContent = {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};